<template>
    <div class="w-full">
        <div class="w-full mb-4">
            <label for="slug" class="py-1">URL Slug</label>
            <input :class="{ 'is-invalid' : errors.slug }" id="slug" class="form-input form-input-sm" v-model="form.slug" type="text" />
            <div v-if="errors.slug" class="error">
                {{ errors.slug[0] }}
            </div>
            <div class="text-xs italic">Prepended the URL like https://www.commoditytrends.com/order/<strong>cttp</strong></div>
        </div>

        <div class="w-full mb-4">
            <label for="summary" class="py-1">Product Summary</label>
            <input :class="{ 'is-invalid' : errors.summary }" id="summary" class="form-input form-input-sm" v-model="form.summary" type="text" />
            <div v-if="errors.summary" class="error">
                {{ errors.summary[0] }}
            </div>
        </div>

        <div class="w-full mb-4">
            <label for="banker_product_id" class="py-1">Product ID</label>
            <input :class="{ 'is-invalid' : errors.banker_product_id }" id="banker_product_id" class="form-input form-input-sm" v-model="form.banker_product_id" type="text" />
            <div v-if="errors.banker_product_id" class="error">
                {{ errors.banker_product_id[0] }}
            </div>
        </div>

        <div class="w-full mb-4">
            <label for="banker_bill_term_id" class="py-1">Bill Term ID</label>
            <input :class="{ 'is-invalid' : errors.banker_bill_term_id }" id="banker_bill_term_id" class="form-input form-input-sm" v-model="form.banker_bill_term_id" type="text" />
            <div v-if="errors.banker_bill_term_id" class="error">
                {{ errors.banker_bill_term_id[0] }}
            </div>
        </div>

        <div class="w-full mb-4">
            <label for="ref_code" class="py-1">Ref Code</label>
            <input :class="{ 'is-invalid' : errors.ref_code }" id="ref_code" class="form-input form-input-sm" v-model="form.ref_code" type="text" />
            <div v-if="errors.ref_code" class="error">
                {{ errors.ref_code[0] }}
            </div>
        </div>

        <div class="w-full mb-4">
            <label for="title" class="py-1">Title</label>
            <input placeholder="Short description of the product" :class="{ 'is-invalid' : errors.title }" id="title" class="form-input form-input-sm" v-model="form.title" type="text" />
            <div v-if="errors.title" class="error">
                {{ errors.title[0] }}
            </div>
        </div>

        <div class="w-full mb-4">
            <label for="terms" class="py-1">Terms</label>
            <input placeholder="(if applicable) e.g. Credit card will be billed $79 a month" :class="{ 'is-invalid' : errors.terms }" id="terms" class="form-input form-input-sm" v-model="form.terms" type="text" />
            <div v-if="errors.terms" class="error">
                {{ errors.terms[0] }}
            </div>
        </div>

        <div class="w-full mb-4">
            <label for="shipping" class="py-1">Shipping</label>
            <input placeholder="(if applicable) e.g. $7 to US $15 to CA" :class="{ 'is-invalid' : errors.shipping }" id="shipping" class="form-input form-input-sm" v-model="form.shipping" type="text" />
            <div v-if="errors.shipping" class="error">
                {{ errors.shipping[0] }}
            </div>
        </div>

        <div class="w-full mb-4">
            <label for="require_credit_card" class="py-1">
                Requires Credit Card
                <input :class="{ 'is-invalid' : errors.require_credit_card }" id="require_credit_card" class="form-control form-control-sm ml-2" v-model="form.require_credit_card" type="checkbox" />
            </label>
            <div v-if="errors.require_credit_card" class="error">
                {{ errors.require_credit_card[0] }}
            </div>
        </div>

        <div class="w-full mb-4">
            <label class="py-1">Description</label>
            <w-editor v-model="form.description" class="pt-2 border-t" height="24rem" :content="form.description"></w-editor>
        </div>

        <div class="w-full mb-4">
            <label class="py-1">Redirect URL</label>
            <input placeholder="(if applicable)" :class="{ 'is-invalid' : errors.redirect_url }" id="redirect_url" class="form-input form-input-sm" v-model="form.redirect_url" type="text" />
            <div v-if="errors.redirect_url" class="error">
                {{ errors.redirect_url[0] }}
            </div>
            <div class="text-xs italic">Where to send user after successful order.</div>
        </div>

        <div class="w-full mb-4">
            <label class="py-1">Agreed Notes</label>
            <w-editor v-model="form.agreed_notes" class="pt-2 border-t" height="6rem" :content="form.agreed_notes"></w-editor>
            <!-- <input placeholder="(if applicable)" :class="{ 'is-invalid' : errors.agreed_notes }" id="agreed_notes" class="form-input form-input-sm" v-model="form.agreed_notes" type="text" /> -->
            <div v-if="errors.agreed_notes" class="error">
                {{ errors.agreed_notes[0] }}
            </div>
            <div class="text-xs italic">Agreed notes when the user affirmatively check a checkbox before accept their order.</div>
        </div>

        <div class="w-full flex mb-4">
            <div v-if="mode === 'edit'" @click="update" class="btn btn-yellow">Update</div>
            <div v-if="mode === 'edit'" @click="showDeleteModal = true" class="ml-2 btn btn-red">Delete</div>
            <div v-if="mode === 'create'" @click="save" class="btn btn-yellow">Save</div>
        </div>

        <modal @close="showDeleteModal = false" v-if="showDeleteModal === true">
            <template #header>Delete this Product?</template>
            <template #body>
                <p class="text-base leading-tight mb-4">
                    Are you sure you want to delete this product? This action cannot be undone.
                </p>
            </template>
            <template #footer>
                <div class="flex justify-center">
                    <div @click="showDeleteModal = false" class="m-1 btn btn-sm btn-yellow-ghost">
                        Close
                    </div>
                    <div @click="destroy" class="btn m-1 btn-sm btn-red">
                        Delete
                    </div>
                </div>
            </template>
        </modal>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    product: {
        type: Object,
        required: true
    },
    mode: {
        type: String,
        required: true
    }
});

const showDeleteModal = ref(false);
const errors = ref({});

const form = ref({
    banker_product_id: props.product.banker_product_id || '',
    banker_bill_term_id: props.product.banker_bill_term_id || '',
    slug: props.product.slug || '',
    title: props.product.title || '',
    terms: props.product.terms || '',
    summary: props.product.summary || '',
    ref_code: props.product.ref_code || '',
    description: props.product.description || '',
    redirect_url: props.product.redirect_url || '',
    require_credit_card: props.product.require_credit_card !== undefined ? props.product.require_credit_card : true,
    agreed_notes: props.product.agreed_notes || '',
});

function update() {
    const route = window.route('admin.products.update', { product: props.product.id });
    errors.value = {};
    axios.patch(route, form.value)
        .then((response) => {
            if (response.data.error) {
                errors.value = {
                    banker_product_id: [response.data.message],
                    banker_bill_term_id: [response.data.message]
                };
                return;
            }
            window.location = window.route('admin.products.index');
        }).catch(error => {
            console.error(error);
            errors.value = error.response.data.errors;
        });
}

function destroy() {
    const route = window.route('admin.products.destroy', {
        product: props.product.id
    });

    axios.delete(route)
        .then((response) => {
            window.location = window.route('admin.products.index');
        }).catch((error) => {
            errors.value = error.response.data.message;
        });
}

function save() {
    const route = window.route('admin.products.store');

    axios.post(route, form.value)
        .then((response) => {
            if (response.data.error) {
                errors.value = {
                    banker_product_id: [response.data.message],
                    banker_bill_term_id: [response.data.message]
                };
                return;
            }
            window.location = window.route('admin.products.index');
        }).catch(error => {
            console.error(error);
            errors.value = error.response.data.errors;
        });
}
</script>
